import * as React from "react";
const MobileSvg = (props) => (
  <svg
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 27.4 27.4"
    style={{
      enableBackground: "new 0 0 27.4 27.4",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <path d="M20.9,0.2H10.4c-1.2,0-2.2,1-2.2,2.2v5.1h0.1c0.4,0,0.8,0,1.2,0.1V3.1h12.2v22c0.1,0,0.3,0,0.4,0c0.3,0,0.5,0,0.8,0L23,2.4                   C23.1,1.2,22.1,0.2,20.9,0.2z M16.4,2.1h-1.5c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4h1.5c0.2,0,0.4,0.2,0.4,0.4S16.6,2.1,16.4,2.1                   z" />
      <path d="M21.9,16.5c0,0.1-0.1,0.1-0.1,0.1v6.1H9.5V21c-0.3-0.3-0.7-0.5-1-0.9c-0.1,0-0.2,0-0.3,0H8V25c0,1.2,1,2.2,2.2,2.2h10.5                   c1.2,0,2.2-1,2.2-2.2v-8.5C22.7,16.5,22.2,16.5,21.9,16.5z M15.6,26.1c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2                   c0.7,0,1.2,0.6,1.2,1.2C16.9,25.6,16.2,26.1,15.6,26.1z" />
    </g>
    <g>
      <path d="M16.6,13.6c0-2.7-3.5-4.9-7.8-4.9C4.6,8.8,1,10.9,1,13.6s3.5,4.9,7.8,4.9c0.3,0,0.6,0,1,0h0.3l0.2,0.3                   c0.5,1,1.7,1.6,2.6,1.9c-0.2-0.8-0.4-1.6-0.4-2.3v-0.4l0.3-0.1C15.1,17,16.6,15.4,16.6,13.6z M5.8,14.7c-0.5,0-0.9-0.4-0.9-0.9                   c0-0.5,0.3-1,0.9-1s0.9,0.4,0.9,0.9C6.6,14.3,6.3,14.7,5.8,14.7z M8.8,14.7c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9                   c0.5,0,0.9,0.4,0.9,0.9C9.8,14.3,9.3,14.7,8.8,14.7z M11.8,14.7c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9                   c0.5,0,0.9,0.4,0.9,0.9C12.8,14.3,12.4,14.7,11.8,14.7z" />
    </g>
  </svg>
);
export default MobileSvg;
